import { ApiResponse } from "./wall";
import { axiosInstance } from "utils";
import { ICandles, IStory } from "pages/People/people.types";
import { AxiosRequestConfig } from "axios";
import { ITributes } from "components/organisms/Tributes/tributes.types";

type StoriesParams = {
  limit?: number;
  offset?: number;
  creator?: string;
};

export const getStories = async (
  isMyStories: boolean,
  params: StoriesParams = {},
  config: AxiosRequestConfig = {}
): Promise<IStory[]> => {
  const {
    limit  = 10_000,
    offset = 0,
    ...restParams
  } = params;

  const url = isMyStories ? "/my-stories/" : "/stories/";

  const response = await axiosInstance.get<ApiResponse<IStory>>(url, {
    params: { limit, offset, ...restParams },
    ...config,
  });

  return response.data.results;
};


export const getStory = async (id: string, isMy: boolean, config?: AxiosRequestConfig): Promise<IStory> => {
  const response = await axiosInstance.get<IStory>(`${isMy ? "/my-stories" : "/stories"}/${id}`,
    config
  );
  return response.data;
};

export const getCandles = async (id: string, config?: AxiosRequestConfig): Promise<ICandles> => {
  const response = await axiosInstance.get<ICandles>(`/candles?story=${id}`,
    config
  );
  return response.data;
};

export const getTributes = async (id: string, config?: AxiosRequestConfig): Promise<ITributes[]> => {
  const response = await axiosInstance.get<ApiResponse<ITributes>>(`/tributes?story=${id}`,
    config
  );
  return response.data.results;
};
